/**
 * Runs a task during browser idle time.
 *
 * `requestIdleCallback` is missing on iOS Safari, where the previous code fell
 * back to running hydration *synchronously* — the worst case on the platform
 * where INP/TBT matter most. This polyfills the fallback with a MessageChannel
 * macrotask (plus a setTimeout safety net) so the work is still yielded off the
 * critical path and can't block the first interaction, while remaining bounded
 * by `timeout`.
 */
export function runWhenIdle(task, timeout = 2000) {
    const w = window;
    if (typeof w.requestIdleCallback === 'function') {
        w.requestIdleCallback(task, { timeout });
        return;
    }
    let ran = false;
    const run = () => {
        if (ran) {
            return;
        }
        ran = true;
        task();
    };
    // MessageChannel yields to the event loop faster than setTimeout(0); the
    // timeout guarantees the task still runs even if messages are starved.
    const channel = new MessageChannel();
    channel.port1.onmessage = run;
    channel.port2.postMessage(undefined);
    setTimeout(run, timeout);
}
